import type { BaseTranslation } from '../i18n-types';

import { auth } from './auth';
import { bannedUser } from './bannedUser';
import { blockedUsers } from './blockedUsers';
import { call } from './call';
import { chat } from './chat';
import { chatRules } from './chatRules';
import { common } from './common';
import { dialogs } from './dialogs';
import { income } from './income';
import { landings } from './landings';
import { landingsAlternative as alternative } from './landingsAlternative';
import { main } from './main';
import { menu } from './menu';
import { message } from './message';
import { onboarding } from './onboarding';
import { payment } from './payment';
import { paymentDetails } from './paymentDetails';
import { paymentFailure } from './paymentFailure';
import { profile } from './profile';
import { referral } from './referral';
import { reportContent } from './reportContent';
import { reportReason } from './reportReason';
import { roomClosedReason } from './roomClosedReason';
import { roomSettings } from './roomSettings';
import { story } from './story';
import { titles } from './titles';
import { unauthorizedStart } from './unauthorizedStart';
import { verifyYourself } from './verifyYourself';
import { welcomePage } from './welcomePage';

const en = {
    ...main,
    ...landings,
    alternative,
    payment,
    common,
    menu,
    story,
    message,
    paymentFailure,
    auth,
    welcomePage,
    titles,
    dialogs,
    verifyYourself,
    reportContent,
    reportReason,
    profile: {
        ...profile,
        paymentDetails,
    },
    chat,
    income,
    onboarding,
    call,
    referral,
    unauthorizedStart,
    roomSettings,
    roomClosedReason,
    chatRules,
    blockedUsers,
    bannedUser,
} satisfies BaseTranslation;

export default en;
